<div class="budget-redirect-block">
    <a mat-flat-button
       color="accent"
       [disableRipple]="true"
       [routerLink]="urlPath"
       [queryParams]="urlQueryParams"
       (click)="onNavigate()">
        <i class="ph-bold ph-arrow-right icon-text icon-16" aria-hidden="true"></i>
        {{ label }}
    </a>
    <span *ngIf="helperText" class="budget-redirect-helper">
        {{ helperText }}
    </span>
</div>
